App.prototype.removeProductFromCart = function (productUid, cb = () => {}) {

    App.prototype.toggleDisabledBasketFields(true);

    $.ajax({
        type: 'DELETE',
        url: App.prototype.apiAddress + 'basket/'+productUid+'/decrease',
        dataType: "json",
        success: function (response) {
            App.prototype.notificationSuccess(translates.product_removed_from_cart);
            App.prototype.buildCart(response);
            App.prototype.reloadBasketPage(response);
        },
        complete: function (){

            App.prototype.toggleDisabledBasketFields(false);

            $('[data-installment-manager]').trigger('cartUpdated');

            cb();

        },
    });
};
